export default "__VITE_ASSET__B7C32JTo__"